<template>
  <div class="swiper-card card-onboarding" :class="feature.theme">
    <div class="corner-radius-blur" :class="feature.theme"></div>
    <div v-if="feature.confetti" class="confetti"></div>

    <div class="image-dial" v-if="feature.dial">
      <UserTrack :size="130" />
    </div>

    <div class="image-container" v-if="feature.images">
      <img class="light" :src="feature.images.light">
      <img class="dark" :src="feature.images.dark">
    </div>

    <div class="main">
      <div class="image-icon newsle-brand" v-if="feature.newsleBrand">
        <base-svg svg="newsle-brand" height="3.2rem" />
      </div>

      <div class="image-icon" v-if="feature.icon" :class="feature.theme">
        <base-svg :svg="feature.icon" height="3rem" />
      </div>

      <div class="onboarding-content" :class="feature.align">
        <h1 v-html="feature.title"></h1>
        <p v-if="feature.body" v-html="feature.body"></p>
        <ul v-if="feature.bullets">
          <li v-for="(feature, idx) in feature.bullets" :key="idx">
            <svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M1.70711 6.53952L3.53811 8.46321L11.2925 0.308091C11.6829 -0.102407 12.316 -0.102739 12.7068 0.307349C13.0975 0.717437 13.0978 1.38265 12.7075 1.79315L4.24592 10.6919C3.85545 11.1026 3.22202 11.1027 2.83135 10.6923L0.292893 8.02532C-0.0976312 7.61503 -0.0976312 6.94981 0.292893 6.53952C0.683417 6.12922 1.31658 6.12922 1.70711 6.53952Z" />
            </svg>
            <span v-html="feature"></span>
          </li>
        </ul>

        <div v-if="feature.features" class="features">
          <div class="feature">
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.7281 2.0017C1.7281 1.04578 2.50047 0.273475 3.45648 0.273475C4.41248 0.273475 5.18485 1.04578 5.18485 2.0017C5.18485 2.95763 4.41248 3.72993 3.45648 3.72993C2.50047 3.72993 1.7281 2.95763 1.7281 2.0017ZM24.197 8.91462C24.197 7.9587 24.9693 7.18639 25.9253 7.18639C26.8813 7.18639 27.6537 7.9587 27.6537 8.91462C27.6537 9.87055 26.8813 10.6429 25.9253 10.6429C24.9693 10.6429 24.197 9.87055 24.197 8.91462ZM25.9253 22.7405C26.8813 22.7405 27.6537 23.5128 27.6537 24.4687C27.6537 25.4246 26.8813 26.1969 25.9253 26.1969C24.9693 26.1969 24.197 25.4246 24.197 24.4687C24.197 23.5128 24.9693 22.7405 25.9253 22.7405ZM9.01968 8.53657C8.51197 8.02891 8.51197 7.208 9.01968 6.70573L9.46798 6.25747C10.37 5.35555 10.9371 4.17279 11.0775 2.90362L11.2396 1.42383C11.3206 0.716334 11.9633 0.203266 12.6763 0.278876C13.3892 0.354486 13.9023 0.997171 13.8213 1.71007L13.6593 3.18986C13.454 5.04231 12.6223 6.77054 11.3044 8.08831L10.8561 8.53657C10.3484 9.04424 9.52739 9.04424 9.02508 8.53657H9.01968ZM19.3899 17.0697L19.8328 16.6268C21.1507 15.3091 22.8791 14.4774 24.7317 14.2721L26.2116 14.1101C26.9245 14.0291 27.5619 14.5422 27.6429 15.2551C27.7239 15.968 27.2108 16.6052 26.4979 16.6863L25.0179 16.8483C23.7487 16.9887 22.5658 17.5558 21.6638 18.4577L21.2263 18.906C20.7186 19.4136 19.8976 19.4136 19.3953 18.906C18.893 18.3983 18.8876 17.5774 19.3953 17.0751L19.3899 17.0697ZM27.3458 0.732536C27.8103 1.27801 27.7401 2.09892 27.1946 2.55798L26.6545 3.01704C25.8551 3.69213 24.8343 4.04858 23.7919 4.02157C22.8953 3.99997 22.1391 4.69126 22.0851 5.58778L21.9879 7.208C21.8529 9.5033 19.9192 11.2747 17.6237 11.2153C17.2133 11.2045 16.8136 11.3449 16.5057 11.6096L15.9656 12.0686C15.4201 12.5331 14.5991 12.4629 14.14 11.9174C13.6809 11.372 13.7457 10.551 14.2912 10.092L14.8313 9.63292C15.6307 8.95783 16.6515 8.60138 17.694 8.62839C18.5905 8.64999 19.3467 7.9587 19.4007 7.06218L19.4979 5.44196C19.633 3.14666 21.5666 1.37522 23.8621 1.43463C24.2726 1.44543 24.6723 1.30501 24.9801 1.04038L25.5202 0.581316C26.0658 0.116854 26.8867 0.187064 27.3458 0.732536ZM3.20262 24.7225L7.89624 22.9619L4.9634 20.0293L3.20262 24.7225ZM14.0104 20.672L7.2589 13.9211L5.96802 17.3667L10.5644 21.9628L14.0104 20.672ZM5.29828 11.7554C5.73037 10.5996 7.2643 10.2648 8.13929 11.1397L16.792 19.7863C17.6669 20.6612 17.3321 22.195 16.1762 22.627L2.33844 27.8171C0.977342 28.3248 -0.399956 26.953 0.107753 25.592L5.29828 11.7554Z" fill="#FFDE00"/>
            </svg>
            <span>No ads. Ever.</span>
          </div>

          <div class="feature">
            <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.31958 2.65905C10.4486 0.792825 12.8477 0.0420459 14.8831 0.985883L15.2739 1.18967C17.1628 2.31047 17.9227 4.68079 16.9674 6.69181L16.2021 8.30062H22.1564L22.558 8.32207C24.5283 8.52049 26.0644 10.1668 26.0644 12.1618C26.0644 12.8696 25.869 13.5239 25.5325 14.0923C25.8636 14.6608 26.059 15.315 26.0644 16.0229C26.0644 17.0043 25.6899 17.8891 25.0874 18.5702C25.158 18.8544 25.196 19.1494 25.196 19.4551C25.196 20.8011 24.4958 21.9755 23.4482 22.6673C23.3451 24.5711 21.8524 26.1102 19.9527 26.2979L19.551 26.3193H13.9007C12.9237 26.3193 11.9521 26.137 11.0456 25.7884L10.6602 25.6275L10.6223 25.6114L10.264 25.4398L10.226 25.4237L9.56383 25.0752C8.89621 24.7266 8.29914 24.2869 7.77807 23.7828C7.55553 25.2253 6.29628 26.3247 4.77649 26.3247H3.03958C1.36238 26.3247 0 24.9786 0 23.3216L0.0108557 11.3037C0.0108557 9.64666 1.37324 8.30062 3.05044 8.30062H4.78734C5.37355 8.30062 5.92176 8.46686 6.38855 8.75645L9.10789 3.04516L9.14046 2.98081L9.28701 2.71268L9.31958 2.66441V2.65905ZM3.05044 10.8747C2.81161 10.8747 2.61621 11.0678 2.61621 11.3037V23.3162C2.61621 23.5522 2.81161 23.7452 3.05044 23.7452H4.78734C5.02617 23.7452 5.22157 23.5522 5.22157 23.3162V11.3037C5.22157 11.0678 5.02617 10.8747 4.78734 10.8747H3.05044ZM13.7758 3.3133C12.9725 2.94327 12.0226 3.2275 11.5667 3.95682L11.4473 4.17133L8.36428 10.6548C8.1743 11.0571 8.06575 11.4861 8.03861 11.9258L8.03318 12.151V18.2055L8.04404 18.6292C8.1743 20.3828 9.20559 21.9594 10.7959 22.796L11.4201 23.1231L11.7621 23.2894C12.4351 23.5897 13.1625 23.7452 13.9007 23.7452H19.551L19.6813 23.7399C20.3381 23.6755 20.8537 23.1231 20.8537 22.4582L20.8428 22.3187C20.8374 22.2705 20.832 22.2276 20.8211 22.1793C20.6746 21.5304 21.0545 20.8815 21.6896 20.6778C22.2161 20.5115 22.5906 20.0235 22.5906 19.4551C22.5906 19.2245 22.5309 19.0153 22.4223 18.8223C22.0804 18.227 22.2704 17.4709 22.8566 17.1062C23.2257 16.8756 23.4645 16.4734 23.4645 16.0229C23.4645 15.6422 23.2962 15.299 23.0194 15.0576C22.7372 14.8109 22.5743 14.4624 22.5743 14.0923C22.5743 13.7223 22.7372 13.3737 23.0194 13.1271C23.2962 12.8857 23.4645 12.5425 23.4645 12.1618L23.4591 12.0331C23.3994 11.4271 22.9109 10.9444 22.2975 10.8854L22.1672 10.8801H14.1612C13.7161 10.8801 13.3036 10.6548 13.0648 10.2848C12.826 9.91479 12.7934 9.44288 12.9834 9.04603L14.6117 5.59781C14.9917 4.79341 14.6877 3.84421 13.9332 3.3991L13.7758 3.3133Z" fill="#FFDE00"/>
            </svg>
            <span>No clickbait headlines.</span>
          </div>
        </div>
      </div>

      <div v-if="feature.dialExplain" class="dial-explain">
       <svg width="346" height="336" viewBox="0 0 346 336" fill="none" xmlns="http://www.w3.org/2000/svg">
<path class="brand" d="M177.54 131.277H169.716V156.333C165.753 148.885 154.586 137.01 147.773 130.867L142.535 135.18C147.243 144.178 149.902 150.656 152.467 158.011C148.93 154.583 145.452 151.4 140.409 147.516L136.182 151.351C139.782 156.876 141.838 160.051 143.216 165.57L139.441 164.477L137.808 170.004L145.479 172.226L149.904 169.319L149.561 167.452C149.184 165.398 148.747 163.605 148.243 161.975L158.425 171.871L163.174 168.831C161.524 163.489 160.224 157.905 158.249 152.869C163.11 158.964 168.13 167.805 169.634 171.388H177.54V131.277Z" fill="white"/>
<g opacity="0.1">
<path d="M231.856 151.048C231.856 191.915 198.726 225.045 157.858 225.045C116.991 225.045 83.8613 191.915 83.8613 151.048C83.8613 110.18 116.991 77.0508 157.858 77.0508C198.726 77.0508 231.856 110.18 231.856 151.048ZM93.2294 151.048C93.2294 186.742 122.165 215.677 157.858 215.677C193.552 215.677 222.488 186.742 222.488 151.048C222.488 115.354 193.552 86.4188 157.858 86.4188C122.165 86.4188 93.2294 115.354 93.2294 151.048Z" fill="white"/>
<path d="M249.794 152.044C249.794 203.094 208.299 244.479 157.111 244.479C105.923 244.479 64.4277 203.094 64.4277 152.044C64.4277 100.995 105.923 59.6104 157.111 59.6104C208.299 59.6104 249.794 100.995 249.794 152.044ZM73.8351 152.044C73.8351 197.913 111.119 235.097 157.111 235.097C203.103 235.097 240.387 197.913 240.387 152.044C240.387 106.176 203.103 68.9924 157.111 68.9924C111.119 68.9924 73.8351 106.176 73.8351 152.044Z" fill="white"/>
<path d="M268.23 151.546C268.23 212.779 218.592 262.418 157.359 262.418C96.127 262.418 46.4883 212.779 46.4883 151.546C46.4883 90.314 96.127 40.6753 157.359 40.6753C218.592 40.6753 268.23 90.314 268.23 151.546ZM55.857 151.546C55.857 207.605 101.301 253.049 157.359 253.049C213.418 253.049 258.862 207.605 258.862 151.546C258.862 95.4882 213.418 50.044 157.359 50.044C101.301 50.044 55.857 95.4882 55.857 151.546Z" fill="white"/>
</g>
<path d="M157.858 81.734C157.858 79.1475 159.957 77.0353 162.539 77.1989C177.129 78.1233 191.157 83.3535 202.823 92.2794C215.732 102.156 225.03 116.009 229.281 131.697C233.531 147.386 232.498 164.037 226.34 179.08C220.183 194.122 209.244 206.719 195.213 214.924C181.182 223.13 164.84 226.487 148.71 224.477C132.581 222.468 117.562 215.204 105.973 203.807C94.3843 192.41 86.8703 177.514 84.5919 161.42C82.5329 146.876 84.8532 132.085 91.2015 118.916C92.3246 116.587 95.1946 115.793 97.4488 117.061V117.061C99.703 118.329 100.485 121.179 99.3837 123.519C94.0322 134.886 92.0952 147.601 93.8658 160.108C95.8558 174.164 102.419 187.174 112.541 197.129C122.663 207.083 135.781 213.428 149.868 215.183C163.956 216.938 178.23 214.006 190.485 206.839C202.74 199.672 212.294 188.67 217.672 175.532C223.05 162.393 223.953 147.849 220.24 134.147C216.528 120.444 208.407 108.345 197.132 99.7182C187.1 92.0428 175.068 87.4962 162.538 86.5867C159.958 86.3995 157.858 84.3204 157.858 81.734V81.734Z" fill="#00E0FF"/>
<path d="M157.111 64.3014C157.111 61.7106 159.213 59.598 161.8 59.7287C176.219 60.4571 190.291 64.5366 202.882 71.6685C216.836 79.5717 228.492 90.9524 236.712 104.697C244.931 118.441 249.432 134.079 249.773 150.078C250.115 166.078 246.285 181.892 238.659 195.973C231.033 210.053 219.872 221.918 206.269 230.406C192.665 238.894 177.085 243.714 161.053 244.395C145.021 245.076 129.087 241.593 114.809 234.289C101.933 227.702 90.8032 218.211 82.2889 206.595C80.7517 204.498 81.3685 201.57 83.5448 200.147V200.147C85.7135 198.729 88.6101 199.343 90.1534 201.425C97.7681 211.695 107.67 220.093 119.103 225.941C131.931 232.504 146.248 235.633 160.653 235.021C175.058 234.41 189.056 230.079 201.279 222.452C213.502 214.826 223.53 204.165 230.382 191.514C237.234 178.863 240.675 164.654 240.368 150.278C240.061 135.902 236.018 121.852 228.632 109.503C221.247 97.1532 210.773 86.9277 198.237 79.8266C187.062 73.4971 174.589 69.8433 161.8 69.1241C159.213 68.9787 157.111 66.8922 157.111 64.3014V64.3014Z" fill="#55E591"/>
<path d="M157.359 45.3596C157.359 42.7725 159.458 40.665 162.042 40.7742C178.308 41.4618 194.244 45.7247 208.707 53.2824C224.556 61.5642 238.166 73.5566 248.377 88.2367C258.589 102.917 265.097 119.849 267.348 137.589C269.403 153.778 267.856 170.201 262.842 185.69C262.045 188.152 259.34 189.386 256.914 188.486V188.486C254.488 187.586 253.263 184.893 254.05 182.428C258.544 168.358 259.918 153.458 258.054 138.768C255.993 122.527 250.035 107.026 240.686 93.5864C231.338 80.1468 218.878 69.1678 204.368 61.5858C191.244 54.728 176.796 50.8334 162.042 50.1521C159.458 50.0327 157.359 47.9467 157.359 45.3596V45.3596Z" fill="#F9E067"/>
<path d="M18.5874 17.7301H22.9147V13.2654H25.479V17.7301H29.8292V20.2257H25.479V24.7133H22.9147V20.2257H18.5874V17.7301ZM34.7217 16.6082L31.7224 16.5166C31.6766 16.3106 31.6079 15.8526 31.6079 15.4863C31.6079 12.8762 33.5769 10.5179 37.0342 10.5179C40.3541 10.5179 42.3918 12.7159 42.3918 15.3031C42.3918 17.2264 41.3386 18.7833 39.5069 19.9052L36.6449 21.6453C36.0726 22.0116 35.5917 22.4237 35.3628 22.9961H42.4834V25.7207H31.4934C31.5163 23.1106 32.3405 20.9813 34.9965 19.3786L37.4463 17.9133C38.7056 17.1577 39.2093 16.3792 39.2093 15.3489C39.2093 14.2728 38.4537 13.3112 36.9655 13.3112C35.3857 13.3112 34.6072 14.3873 34.6072 15.784C34.6072 16.0587 34.653 16.3563 34.7217 16.6082ZM55.7557 16.9287C54.1988 16.9287 52.8938 18.0506 52.8938 20.0884C52.8938 22.1261 54.2217 23.2709 55.7786 23.2709C57.3355 23.2709 58.114 22.2406 58.3658 21.3705L61.0447 22.2634C60.5409 24.1409 58.778 26.0641 55.7786 26.0641C52.4587 26.0641 49.8486 23.5456 49.8486 20.0884C49.8486 16.6082 52.413 14.1126 55.687 14.1126C58.7551 14.1126 60.4952 16.0129 60.976 17.9133L58.2514 18.8291C57.9766 17.8904 57.2669 16.9287 55.7557 16.9287ZM68.4781 23.2938C69.9663 23.2938 71.34 22.2177 71.34 20.0884C71.34 17.959 69.9663 16.8829 68.4781 16.8829C66.9899 16.8829 65.6161 17.959 65.6161 20.0884C65.6161 22.1948 66.9899 23.2938 68.4781 23.2938ZM68.4781 14.1126C71.8437 14.1126 74.3852 16.6082 74.3852 20.0884C74.3852 23.5456 71.8437 26.0641 68.4781 26.0641C65.1124 26.0641 62.571 23.5456 62.571 20.0884C62.571 16.6082 65.1124 14.1126 68.4781 14.1126ZM84.1799 25.7207C84.1341 25.4917 84.0883 24.9651 84.0883 24.5072C83.4701 25.5604 82.1651 26.0183 80.9745 26.0183C78.2499 26.0183 76.693 24.0264 76.693 21.5766V14.456H79.7381V20.9584C79.7381 22.2177 80.3792 23.2251 81.7987 23.2251C83.1496 23.2251 83.9281 22.3092 83.9281 21.0042V14.456H86.9732V23.683C86.9732 24.553 87.0419 25.3315 87.0877 25.7207H84.1799ZM93.1339 19.2412V25.7207H90.0888V14.456H93.0423V15.8526C93.7292 14.685 95.0801 14.1584 96.2935 14.1584C99.0868 14.1584 100.369 16.1503 100.369 18.623V25.7207H97.3238V19.1496C97.3238 17.8904 96.7057 16.9058 95.2403 16.9058C93.9124 16.9058 93.1339 17.9362 93.1339 19.2412ZM107.331 11.0903V14.456H109.598V17.1577H107.331V21.8742C107.331 22.8587 107.789 23.1793 108.659 23.1793C109.025 23.1793 109.437 23.1335 109.598 23.0877V25.6062C109.323 25.7207 108.774 25.881 107.881 25.881C105.683 25.881 104.309 24.5759 104.309 22.4008V17.1577H102.271V14.456H102.844C104.034 14.456 104.584 13.6775 104.584 12.6701V11.0903H107.331ZM118.914 14.4102V17.4782C118.571 17.4095 118.273 17.3867 117.998 17.3867C116.441 17.3867 115.091 18.1422 115.091 20.5692V25.7207H112.045V14.456H114.999V16.1274C115.686 14.6392 117.243 14.3644 118.204 14.3644C118.456 14.3644 118.685 14.3873 118.914 14.4102ZM123.967 25.7207H120.922V14.456H123.967V25.7207ZM120.556 10.7698C120.556 9.71658 121.403 8.86944 122.433 8.86944C123.486 8.86944 124.311 9.71658 124.311 10.7698C124.311 11.7772 123.486 12.6243 122.433 12.6243C121.403 12.6243 120.556 11.7772 120.556 10.7698ZM129.475 18.8062H134.512C134.466 17.6843 133.733 16.5853 131.993 16.5853C130.414 16.5853 129.544 17.7759 129.475 18.8062ZM134.81 21.7368L137.351 22.4924C136.779 24.4385 134.993 26.0641 132.222 26.0641C129.131 26.0641 126.407 23.8433 126.407 20.0426C126.407 16.4479 129.063 14.1126 131.948 14.1126C135.428 14.1126 137.511 16.3334 137.511 19.951C137.511 20.386 137.465 20.8439 137.465 20.8897H129.406C129.475 22.3779 130.734 23.454 132.245 23.454C133.665 23.454 134.443 22.7443 134.81 21.7368ZM139.216 22.584L141.827 22.0116C141.895 22.9045 142.559 23.7288 143.887 23.7288C144.895 23.7288 145.375 23.2022 145.375 22.6069C145.375 22.1032 145.032 21.6911 144.162 21.5079L142.674 21.1645C140.499 20.6836 139.514 19.3786 139.514 17.7988C139.514 15.784 141.3 14.1126 143.727 14.1126C146.932 14.1126 148.008 16.1503 148.146 17.3638L145.604 17.9362C145.513 17.2722 145.032 16.425 143.75 16.425C142.948 16.425 142.307 16.9058 142.307 17.5469C142.307 18.0964 142.719 18.4399 143.338 18.5543L144.94 18.8978C147.161 19.3557 148.283 20.7065 148.283 22.355C148.283 24.1867 146.864 26.0641 143.91 26.0641C140.521 26.0641 139.354 23.8661 139.216 22.584Z" fill="#00E0FF"/>
<path d="M82.9172 38.1244C83.9132 38.1404 84.6648 39.3782 84.9328 40.1857C85.1316 40.785 85.4309 42.4679 84.476 42.6532C78.0386 43.9028 71.8206 46.107 66.623 50.0894C61.4802 54.0299 57.3611 59.2061 54.7961 65.181C53.5381 68.1111 52.7132 71.0609 52.3378 74.2385C52.244 75.0314 52.1782 75.8284 52.1408 76.6277C52.1025 77.4473 52.1049 77.7129 52.1402 78.6965C52.1683 79.4827 52.2226 80.2688 52.3029 81.0531C52.3401 81.4189 52.3838 81.7842 52.4324 82.1491C52.4602 82.3577 52.4896 82.5659 52.5212 82.774C52.5293 82.8284 52.5652 83.0304 52.5855 83.1474C52.8797 84.7054 53.2592 86.2469 53.7391 87.7642C53.7865 87.9142 53.9459 88.3727 53.9699 88.4487C54.0864 88.7677 54.2027 89.0868 54.3269 89.4034C54.6361 90.1924 54.9701 90.9722 55.328 91.7417C55.4848 92.0787 55.6463 92.4134 55.8121 92.7462C55.8826 92.8879 56.0912 93.2862 56.1379 93.3801C56.5056 94.0537 56.886 94.7207 57.2886 95.3747C57.7074 96.0549 58.1455 96.7238 58.6022 97.3802C58.8154 97.6866 59.0359 97.9874 59.2533 98.2909C59.2944 98.3483 59.3266 98.3935 59.3543 98.4321C59.4934 98.6126 59.6346 98.7919 59.7771 98.9697C60.9426 100.425 62.2039 101.805 63.5528 103.093C63.6683 103.204 63.785 103.313 63.9013 103.422C63.9558 103.473 63.9899 103.504 64.006 103.52C64.0451 103.554 64.0843 103.589 64.1234 103.624C64.484 103.939 64.8462 104.252 65.2158 104.556C65.9131 105.13 66.6292 105.68 67.3636 106.205C69.1435 107.478 70.9427 108.595 72.8021 109.632C72.5848 109.332 72.3689 109.032 72.1558 108.732C69.3114 104.731 66.9374 100.47 65.4529 95.8122C65.1827 94.9644 65.2025 93.4324 66.1759 93.0342C67.1591 92.6318 68.2729 93.6938 68.7348 94.4692C70.8559 98.0308 72.8288 101.682 75.1934 105.099C77.4761 108.397 80.2354 111.287 82.9944 114.449C83.8354 115.413 84.4359 116.753 84.3793 118.024C84.3432 118.835 83.9847 120.095 82.9006 119.966C78.858 119.485 74.7524 119.344 70.6969 119.029C68.7361 118.877 66.7757 118.719 64.8154 118.556C62.7402 118.384 60.4622 118.354 58.4701 117.653C57.3891 117.272 55.8245 114.144 57.4311 113.628C59.2753 113.035 61.5334 113.26 63.4666 113.27C65.1294 113.278 66.7922 113.292 68.4553 113.309C65.1568 111.293 62.186 108.659 59.5899 105.811C54.4323 100.152 50.6501 93.238 48.7553 85.8845C46.8819 78.614 47.0112 71.0347 49.3165 64.0095C51.5168 57.3047 55.7469 51.2778 61.107 46.7692C67.105 41.7228 74.8285 37.9947 82.9172 38.1244Z" fill="#00E0FF"/>
<path d="M0.732664 318.552H5.05996V314.088H7.62428V318.552H11.9745V321.048H7.62428V325.536H5.05996V321.048H0.732664V318.552ZM16.867 317.43L13.8677 317.339C13.8219 317.133 13.7532 316.675 13.7532 316.309C13.7532 313.698 15.7222 311.34 19.1795 311.34C22.4994 311.34 24.5371 313.538 24.5371 316.125C24.5371 318.049 23.4839 319.606 21.6522 320.727L18.7902 322.468C18.2179 322.834 17.737 323.246 17.5081 323.818H24.6287V326.543H13.6387C13.6616 323.933 14.4858 321.804 17.1418 320.201L19.5916 318.736C20.8509 317.98 21.3546 317.202 21.3546 316.171C21.3546 315.095 20.599 314.133 19.1108 314.133C17.531 314.133 16.7525 315.21 16.7525 316.606C16.7525 316.881 16.7983 317.179 16.867 317.43ZM36.2393 311.913V315.278H38.506V317.98H36.2393V322.696C36.2393 323.681 36.6972 324.002 37.5673 324.002C37.9336 324.002 38.3457 323.956 38.506 323.91V326.428C38.2312 326.543 37.6817 326.703 36.7888 326.703C34.5908 326.703 33.2171 325.398 33.2171 323.223V317.98H31.1793V315.278H31.7517C32.9423 315.278 33.4918 314.5 33.4918 313.492V311.913H36.2393ZM46.0621 324.116C47.5503 324.116 48.9241 323.04 48.9241 320.911C48.9241 318.781 47.5503 317.705 46.0621 317.705C44.5739 317.705 43.2001 318.781 43.2001 320.911C43.2001 323.017 44.5739 324.116 46.0621 324.116ZM46.0621 314.935C49.4278 314.935 51.9692 317.43 51.9692 320.911C51.9692 324.368 49.4278 326.886 46.0621 326.886C42.6964 326.886 40.155 324.368 40.155 320.911C40.155 317.43 42.6964 314.935 46.0621 314.935ZM57.4366 330.893H54.3915V315.278H57.3451V316.652C57.8488 315.782 59.108 315.026 60.8023 315.026C64.0993 315.026 65.9997 317.545 65.9997 320.888C65.9997 324.299 63.8703 326.818 60.6878 326.818C59.1309 326.818 57.9861 326.2 57.4366 325.444V330.893ZM63.0003 320.911C63.0003 318.919 61.7639 317.751 60.207 317.751C58.6501 317.751 57.3909 318.919 57.3909 320.911C57.3909 322.903 58.6501 324.093 60.207 324.093C61.7639 324.093 63.0003 322.925 63.0003 320.911ZM71.5005 326.543H68.4554V315.278H71.5005V326.543ZM68.0891 311.592C68.0891 310.539 68.9362 309.692 69.9665 309.692C71.0197 309.692 71.844 310.539 71.844 311.592C71.844 312.599 71.0197 313.447 69.9665 313.447C68.9362 313.447 68.0891 312.599 68.0891 311.592ZM79.8244 317.751C78.2675 317.751 76.9624 318.873 76.9624 320.911C76.9624 322.948 78.2904 324.093 79.8473 324.093C81.4042 324.093 82.1826 323.063 82.4345 322.193L85.1133 323.086C84.6096 324.963 82.8466 326.886 79.8473 326.886C76.5274 326.886 73.9173 324.368 73.9173 320.911C73.9173 317.43 76.4816 314.935 79.7557 314.935C82.8237 314.935 84.5638 316.835 85.0446 318.736L82.32 319.651C82.0453 318.713 81.3355 317.751 79.8244 317.751ZM86.5709 323.406L89.1811 322.834C89.2497 323.727 89.9137 324.551 91.2417 324.551C92.2491 324.551 92.7299 324.024 92.7299 323.429C92.7299 322.925 92.3865 322.513 91.5164 322.33L90.0282 321.987C87.8531 321.506 86.8686 320.201 86.8686 318.621C86.8686 316.606 88.6545 314.935 91.0814 314.935C94.2868 314.935 95.3629 316.973 95.5003 318.186L92.9589 318.758C92.8673 318.094 92.3865 317.247 91.1043 317.247C90.3029 317.247 89.6619 317.728 89.6619 318.369C89.6619 318.919 90.074 319.262 90.6922 319.377L92.2949 319.72C94.5158 320.178 95.6377 321.529 95.6377 323.177C95.6377 325.009 94.2181 326.886 91.2646 326.886C87.876 326.886 86.7083 324.688 86.5709 323.406Z" fill="#55E591"/>
<path d="M63.4018 298.381C64.4218 298.654 65.3964 297.559 65.8051 296.779C66.1085 296.201 66.6956 294.501 65.7513 294.026C59.3856 290.826 53.4037 286.675 48.7613 280.934C44.1678 275.252 40.8266 268.557 39.2062 261.466C38.4113 257.989 38.0622 254.617 38.2102 251.133C38.247 250.264 38.3131 249.399 38.4086 248.539C38.5065 247.658 38.5535 247.376 38.754 246.342C38.9142 245.516 39.1011 244.697 39.3142 243.887C39.4135 243.51 39.5191 243.135 39.6298 242.761C39.6931 242.548 39.758 242.335 39.8251 242.124C39.8424 242.068 39.9129 241.864 39.9532 241.746C40.5142 240.177 41.1596 238.651 41.9035 237.179C41.977 237.034 42.2164 236.594 42.2537 236.52C42.426 236.215 42.5982 235.91 42.778 235.61C43.2257 234.862 43.6973 234.131 44.1915 233.419C44.4079 233.106 44.629 232.798 44.8539 232.493C44.9496 232.363 45.2292 232.001 45.2927 231.915C45.7808 231.306 46.2809 230.709 46.8015 230.132C47.343 229.531 47.9023 228.949 48.4785 228.385C48.7475 228.121 49.023 227.866 49.2958 227.607C49.3474 227.558 49.3879 227.519 49.4225 227.487C49.5948 227.335 49.769 227.186 49.9443 227.039C51.378 225.833 52.897 224.735 54.4902 223.759C54.6266 223.676 54.764 223.594 54.9011 223.512C54.9651 223.474 55.0052 223.45 55.0243 223.439C55.0701 223.413 55.1158 223.388 55.1617 223.362C55.5827 223.132 56.0048 222.906 56.4332 222.691C57.2413 222.284 58.0648 221.908 58.9026 221.564C60.9332 220.731 62.9577 220.068 65.0302 219.509C64.7581 219.764 64.4874 220.019 64.2196 220.276C60.6454 223.697 57.5082 227.53 55.213 232.044C54.7953 232.865 54.5593 234.498 55.4869 235.204C56.4237 235.917 57.7389 235.114 58.3403 234.425C61.1022 231.261 63.728 227.957 66.7143 225.018C69.5973 222.181 72.8988 219.915 76.2455 217.36C77.2656 216.582 78.1031 215.334 78.2578 213.967C78.3565 213.097 78.201 211.654 77.0723 211.475C72.8631 210.81 68.6463 209.764 64.4518 208.918C62.4237 208.508 60.3951 208.105 58.3658 207.708C56.2174 207.287 53.8859 206.655 51.734 206.821C50.5662 206.91 48.4453 209.776 49.9996 210.792C51.7841 211.958 54.128 212.376 56.1041 212.928C57.8037 213.404 59.5043 213.873 61.2056 214.339C57.4997 215.52 54.025 217.452 50.8973 219.72C44.6833 224.227 39.6641 230.468 36.499 237.725C33.3698 244.899 32.2342 252.985 33.4138 261.115C34.5397 268.875 37.8521 276.506 42.5724 282.854C47.8543 289.958 55.119 296.164 63.4018 298.381Z" fill="#55E591"/>
<path d="M243.275 282.055H247.603V277.591H250.167V282.055H254.517V284.551H250.167V289.038H247.603V284.551H243.275V282.055ZM262.209 290.046H259.072V280.109H255.5V277.98C257.676 277.957 259.187 276.743 259.484 275.187H262.209V290.046ZM273.73 290.046H270.685V278.781H273.592V280.155C274.211 279.056 275.653 278.461 276.889 278.461C278.423 278.461 279.66 279.125 280.232 280.338C281.125 278.964 282.316 278.461 283.804 278.461C285.887 278.461 287.879 279.72 287.879 282.742V290.046H284.926V283.36C284.926 282.147 284.33 281.231 282.934 281.231C281.629 281.231 280.85 282.238 280.85 283.452V290.046H277.828V283.36C277.828 282.147 277.21 281.231 275.836 281.231C274.508 281.231 273.73 282.216 273.73 283.452V290.046ZM293.92 290.046H290.875V278.781H293.92V290.046ZM290.509 275.095C290.509 274.042 291.356 273.195 292.386 273.195C293.439 273.195 294.263 274.042 294.263 275.095C294.263 276.102 293.439 276.95 292.386 276.95C291.356 276.95 290.509 276.102 290.509 275.095ZM300.069 283.566V290.046H297.024V278.781H299.977V280.178C300.664 279.01 302.015 278.484 303.228 278.484C306.022 278.484 307.304 280.475 307.304 282.948V290.046H304.259V283.475C304.259 282.216 303.641 281.231 302.175 281.231C300.847 281.231 300.069 282.261 300.069 283.566ZM317.677 290.046C317.632 289.817 317.586 289.29 317.586 288.832C316.968 289.886 315.663 290.344 314.472 290.344C311.747 290.344 310.191 288.352 310.191 285.902V278.781H313.236V285.284C313.236 286.543 313.877 287.55 315.296 287.55C316.647 287.55 317.426 286.634 317.426 285.329V278.781H320.471V288.008C320.471 288.878 320.539 289.657 320.585 290.046H317.677ZM327.547 275.416V278.781H329.814V281.483H327.547V286.199C327.547 287.184 328.005 287.504 328.875 287.504C329.242 287.504 329.654 287.459 329.814 287.413V289.931C329.539 290.046 328.99 290.206 328.097 290.206C325.899 290.206 324.525 288.901 324.525 286.726V281.483H322.487V278.781H323.06C324.25 278.781 324.8 278.003 324.8 276.995V275.416H327.547ZM334.554 283.131H339.591C339.545 282.009 338.813 280.91 337.072 280.91C335.493 280.91 334.623 282.101 334.554 283.131ZM339.889 286.062L342.43 286.818C341.858 288.764 340.072 290.389 337.301 290.389C334.21 290.389 331.486 288.168 331.486 284.368C331.486 280.773 334.142 278.438 337.027 278.438C340.507 278.438 342.59 280.659 342.59 284.276C342.59 284.711 342.545 285.169 342.545 285.215H334.485C334.554 286.703 335.813 287.779 337.324 287.779C338.744 287.779 339.522 287.069 339.889 286.062Z" fill="#F9E067"/>
<path d="M296.683 264.395C295.635 264.67 294.531 263.576 294.044 262.797C293.683 262.22 292.939 260.521 293.892 260.045C300.318 256.835 306.27 252.676 310.699 246.929C315.081 241.242 318.074 234.543 319.235 227.452C319.805 223.974 319.916 220.602 319.498 217.12C319.393 216.251 319.259 215.386 319.094 214.527C318.925 213.646 318.854 213.365 318.566 212.331C318.336 211.505 318.078 210.687 317.794 209.878C317.661 209.501 317.522 209.126 317.378 208.753C317.296 208.54 317.212 208.327 317.125 208.116C317.103 208.06 317.014 207.856 316.963 207.738C316.256 206.171 315.465 204.646 314.574 203.176C314.487 203.031 314.202 202.591 314.158 202.517C313.954 202.213 313.751 201.908 313.54 201.609C313.014 200.862 312.465 200.132 311.894 199.42C311.643 199.108 311.389 198.801 311.13 198.496C311.02 198.366 310.7 198.004 310.627 197.919C310.069 197.311 309.501 196.715 308.912 196.139C308.299 195.539 307.669 194.958 307.023 194.395C306.721 194.132 306.413 193.877 306.108 193.619C306.05 193.57 306.005 193.531 305.966 193.499C305.774 193.348 305.581 193.199 305.386 193.052C303.793 191.848 302.119 190.753 300.377 189.78C300.227 189.697 300.077 189.616 299.928 189.534C299.858 189.496 299.814 189.473 299.793 189.461C299.743 189.435 299.693 189.41 299.643 189.384C299.185 189.156 298.726 188.93 298.261 188.715C297.384 188.31 296.493 187.936 295.589 187.594C293.399 186.764 291.229 186.105 289.016 185.548C289.32 185.803 289.623 186.058 289.923 186.314C293.925 189.728 297.501 193.555 300.246 198.064C300.745 198.884 301.116 200.516 300.198 201.223C299.27 201.938 297.832 201.137 297.15 200.449C294.018 197.291 291.018 193.993 287.668 191.059C284.434 188.227 280.805 185.968 277.106 183.419C275.979 182.642 275.007 181.396 274.742 180.03C274.573 179.16 274.626 177.718 275.795 177.537C280.154 176.865 284.491 175.813 288.821 174.96C290.914 174.547 293.009 174.141 295.104 173.74C297.322 173.316 299.717 172.681 301.983 172.842C303.213 172.93 305.651 175.791 304.1 176.81C302.319 177.979 299.896 178.4 297.868 178.955C296.123 179.433 294.377 179.905 292.631 180.374C296.602 181.548 300.387 183.474 303.835 185.737C310.684 190.233 316.413 196.463 320.276 203.712C324.096 210.88 325.897 218.961 325.276 227.091C324.683 234.851 321.791 242.484 317.326 248.838C312.331 255.949 305.191 262.165 296.683 264.395Z" fill="#F9E067"/>
</svg>

      </div>

      <div v-if="feature.meta" class="meta-block">
        <MetaBlock :theme="feature.theme ? feature.theme : null" :items="feature.meta" />
      </div>
      <!-- <button class="next" @click="next()">Next</button> -->
    </div>

    <div v-if="feature.cover" class="feature-cover" :class="{'stretch' : slide.template === 'read'}" :style="{backgroundImage: `url(${feature.cover})`}"></div>

    <div class="tab-callout-marker" v-if="feature.tabCallout" :class="feature.theme">
      <span v-html="feature.tabCallout"></span>
      <svg width="36" height="44" viewBox="0 0 36 44" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0.795711C1.83903 -0.403354 3.64468 -0.0480496 5.26089 0.56486C7.48957 1.41 9.715 2.42594 11.6967 3.74367C20.7769 9.78168 26.1581 18.4067 28.4435 29.029C29.0317 31.7628 29.1948 34.5897 29.5862 37.6306C32.094 36.1827 33.3638 33.3736 35.9086 31.7023C36.236 32.9536 35.6189 33.765 35.0869 34.4915C33.0043 37.3355 30.894 40.1614 28.7061 42.9233C27.644 44.264 26.8187 44.3416 25.686 43.2177C23.3433 40.8933 21.855 38.0817 21.443 34.7532C21.4252 34.6095 21.6506 34.4351 21.8791 34.109C24.5562 34.816 23.9174 38.2633 26.2588 39.5402C27.24 35.1783 26.5005 31.0642 25.3642 27.0016C24.1906 22.8057 22.6341 18.762 20.1198 15.1594C17.6722 11.6526 14.6077 8.77185 11.2771 6.13815C7.93925 3.49878 4.17706 1.81146 0 0.795711Z" fill="#FFDE00"/>
      </svg>
    </div>

    <RouterLink v-if="feature.action" :to="feature.action.route" class="feature-action btn btn-primary">
      {{ feature.action.label }}
    </RouterLink>

    <button v-if="feature.event" class="feature-action btn btn-primary" @click="handleEvent(feature.event.emit)">{{ feature.event.label }}</button>
  </div>
</template>

<script>
  import UserTrack from '@/components/v5/elements/UserTrack.vue';
  import MetaBlock from '@/components/v5/elements/MetaBlock.vue';

  export default {
    props: {
      slide: {
        type: Object,
      },
      isActive: {
        type: Boolean,
      }
    },

    components: {
      UserTrack,
      MetaBlock
    },

    mounted() {
      if (this.isActive) {
        this.autoEnableNext();
      }
    },

    methods: {
      slideActivated() {
        this.autoEnableNext();
      },

      autoEnableNext() {
        const delay = 1.5;
        window.setTimeout(() => {
          this.$emit('enableNextAction');
        }, 1000 * delay);
      },

      next() {
        this.$emit('next');
      },

      handleEvent(type) {
        this.EventBus.$emit(type, {
          didSelect: 'true' 
        });
      }
    },

    computed: {
      getAccount() {
        return this.$store.getters.getAccount;
      },

      feature() {
        return this.templates[this.slide?.template] || {};
      },

      profileSetup() {
        return this.$userEngine.getPref('nourish.invites.setup');
      },

      getDialFocus() {
        return this.$userEngine.getPref("nourish.onboarding.focus") || "";
      },

      templates() {
        return {
          // open: {
          //   title: `Start your healthy news diet today`,
          //   images: {
          //     dark: require('@assets/images/onboarding/onboarding-graphic-dark.png'),
          //     light: require('@assets/images/onboarding/onboarding-graphic-light.png'),
          //   },
          //   bullets: [
          //     `Feel better`,
          //     `Feel more informed`,
          //     `Feel less anxious about the future`,
          //     `Understand more about the world`,
          //   ]
          // },
          why: {
            title: `Time to detox…`,
            images: {
              dark: require('@assets/images/onboarding/onboarding-graphic-alt-dark.png'),
              light: require('@assets/images/onboarding/onboarding-graphic-alt-light.png'),
            },
            body: `To make the most of Nourish we ask that you to try our “ten day news detox”.`,
            bullets: [
              `We create a balanced news diet`,
              `You read just a little each day`,
              `You'll still be fully informed`,
              `You'll feel better about the world`,
            ],
          },
          nourish: {
            title: `Nourish is news,<br><span class="callout">without nonsense</span>.`,
            features: true,
            tabCallout: 'Get introduced<br>to Nourish',
          },
          read: {
            theme: 'locales',
            align: 'mid',
            title: `Only what<br><span class="callout">you need</span> to know.`,
            cover: require('@assets/images/onboarding/onboarding-phone.png'),
            meta: [
              {
                icon: 'meta-time',
                content: 'Quick<br>summaries',
              },
              {
                icon: 'meta-analysis',
                content: 'Deep<br>analysis',
              }
            ]
          },
          watch: {
            theme: 'topics',
            align: 'mid',
            title: `A new way to <span class="markout">read</span> <span class="callout">watch</span> the news.`,
            cover: require('@assets/images/onboarding/onboarding-watch.png'),
            meta: [
              {
                icon: 'meta-video',
                content: 'Free video<br>summaries',
              },
              {
                icon: 'meta-celebrate',
                content: 'New news<br>experience',
              }
            ]
          },
          track: {
            theme: 'time',
            align: 'mid',
            title: `Take <span class="callout">control</span><br>of your<br>news diet.`,
            dialExplain: true,
            meta: [
              {
                icon: 'meta-track',
                content: 'Track your<br>reading habits',
              },
              {
                icon: 'meta-relax',
                content: 'Get your free<br>time back',
              }
            ]
          },
          detox: {
            icon: 'meta-wave',
            title: `Detox your news diet in <span class="callout">7 days</span>.`,
            body: `We'll ask you a few questions and personalise your Nourish. You'll feel better about reading the news in less than a week.`,
            tabCallout: 'Ready for<br>better news?',
          },
          pledge: {
            title: `Who are Nourish?`,
            images: {
              dark: require('@assets/images/onboarding/onboarding-graphic-people-dark.png'),
              light: require('@assets/images/onboarding/onboarding-graphic-people-light.png'),
            },
            body: `We are a small, approachable team working to make the world a better place.`,
            bullets: [
              `No nasty cookies or adverts`,
              `No selling you or your data`,
              `Independent & approachable`,
              `Working to make news better`
            ]
          },
          qna: {
            title: `Last thing…`,
            images: {
              dark: require('@assets/images/onboarding/onboarding-graphic-alt-dark.png'),
              light: require('@assets/images/onboarding/onboarding-graphic-alt-light.png'),
            },
            body: `For this to work, we need to understand a few things, is that okay?`,
            bullets: [
              `How the news makes you feel`,
              `Where that news is coming from`,
              `.. and how much you're seeing`,
            ],
          },
          ready: {
            title: `Okay! Ready?…`,
            images: {
              dark: require('@assets/images/onboarding/onboarding-graphic-alt-dark.png'),
              light: require('@assets/images/onboarding/onboarding-graphic-alt-light.png'),
            },
            body: `Fantastic.  We're ready to get you started.  This is what ten days looks like.`,
            bullets: [
              `Choose what to focus on`,
              `Read a little each day`,
              `Unlock a new focus every 3 days`,
              `Feel better and more informed`,
            ],
          },


          /**
           *  Deeper coaching... 
           */
          'dashboard-intro': {
            theme: this.getDialFocus,
            dial: true,
            title: `Your dial keeps you on <span class="callout">track</span>`,
            body: `Your goal is to complete your rings each day. When your dial is full, you've covered the right amount of news.`,
            tabCallout: `More about<br>your detox`
            // body: `Your dashboard gives you real-time insight into your reading history and progress. Access it anytime from your profile tab.`,
            // bullets: [
            //   `Check out months of reading stats`,
            //   `See your daily ring progress`,
            //   `View your reading streaks`,
            // ],
          },

          'dashboard-detox': {
            theme: this.getDialFocus,
            dial: true,
            title: `The 7 day <span class="callout">detox</span>`,
            body: `Over the next week, you'll unlock 2 more rings, giving you more to focus on. By the end, you'll be reading topics and countries for just the right amount of time.`,
            tabCallout: `Learn about<br>your dashboard`,
            // title: `Discover into your reading history`,
            // images: {
            //   dark: require('@assets/images/onboarding/onboarding-dashboard-cal-dark.png'),
            //   light: require('@assets/images/onboarding/onboarding-dashboard-cal-light.png'),
            // },
            // body: `Use the calendar and head back to any date in the past and see how you've progressed`,
            // bullets: [
            //   `Full history of reading stats`,
            //   `Explore your progress`,
            //   `Discover gaps in your reading`,
            // ],
          },

          'dashboard-dashboard': {
            theme: this.getDialFocus,
            icon: 'onboarding-deeper',
            title: `Explore <span class="callout">deeper</span> reading insights`,
            body: `Your dashboard gives you real-time insight into your reading history and progress. Access it anytime from your profile tab.`,
            // title: `Ready to explore your progress?`,
            // images: {
            //   dark: require('@assets/images/onboarding/onboarding-dashboard-card.png'),
            //   light: require('@assets/images/onboarding/onboarding-dashboard-card.png'),
            // },
            // body: `Dive into your dashboard and check out all your previous reading statistics.`,
            action: {
              route: '/dashboard',
              label: 'Check out your dashboard'
            }
          },

          'newsle-knowledge': {
            theme: 'newsle',
            confetti: true,
            newsleBrand: true,
            title: `Keep your brain healthy with <span class="callout">Newsle</span>`,
            // images: {
            //   dark: require('@assets/images/onboarding/onboarding-newsle-header-dark.png'),
            //   light: require('@assets/images/onboarding/onboarding-newsle-header-light.png'),
            // },
            body: `Test your knowledge with a fun game to guess the top leading story of the day with emojis.`,
            tabCallout: `Match with emojis`,
          },

          'newsle-emojis': {
            theme: 'newsle',
            confetti: true,
            icon: 'onboarding-icons',
            title: `Match the <span class="callout">emoji</span> to today's leading stories`,
            // images: {
            //   dark: require('@assets/images/onboarding/onboarding-newsle-emojis.png'),
            //   light: require('@assets/images/onboarding/onboarding-newsle-emojis.png'),
            // },
            body: `You have 5 guesses to pick the right emojis that represent one of the leading stories of the day.`,
            tabCallout: `Let's play Newsle`,
          },

          'newsle-play': {
            theme: 'newsle',
            confetti: true,
            icon: 'onboarding-trophy',
            title: `Ready to play <span class="callout">Newsle</span>?`,
            // images: {
            //   dark: require('@assets/images/onboarding/onboarding-newsle-play.png'),
            //   light: require('@assets/images/onboarding/onboarding-newsle-play.png'),
            // },
            body: `Keep your brain healthy and try <span class="callout">Newsle</span> now. Get two games per day, absolutely free.`,
            action: {
              route: '/n/newsle',
              label: 'Try Newsle'
            }
          },

          'invite-intro': {
            icon: 'onboarding-wave',
            title: `Invite friends and unlock more <span class="callout">Nourish</span>.`,
            body: `Unlock up to 5 channels for free just by inviting friends to Nourish. You'll also help our small team just trying to make the news better.`,
            tabCallout: `Learn about invites`
          },

          'invite-unlock': {
            icon: 'onboarding-unlock',
            title: `Unlock 5 channels totally <span class="callout">free</span>.`,
            body: `For every friend that accepts your invite, you'll earn an unlock. Use these unlocks on channels that interest you the most.`,
            meta: [
              {
                icon: 'meta-unlock',
                content: 'Unlock 5<br>channels free',
              },
              {
                icon: 'meta-celebrate',
                content: 'Support our<br>small team',
              }
            ]
          },

          'invite-profile': {
            icon: 'onboarding-ghost',
            title: 'Personalise your <span class="callout">profile</span>',
            body: `Inviting friends is easy. Just complete your profile setup and send your unique invite link to friends.<br><br>For every friend that joins, We'll reward you with an unlock to use on any channel.`,
            action: {
              route: `/~${this.getAccount.screen_name}/invite`,
              label: 'See your profile'
            }
          },

          'more-explore': {
            theme: 'misc',
            icon: 'onboarding-deeper',
            title: `Explore more <span class="callout">news</span> through topics`,
            // images: {
            //   dark: require('@assets/images/onboarding/more-intro.png'),
            //   light: require('@assets/images/onboarding/more-intro.png'),
            // },
            body: `The <span class="callout">Headlines</span> tab let's you jump into more long-form news on the topics that interest you the most.`,
            // bullets: [
            //   `Wide range of topic coverage`,
            //   `Deep dive any topic`,
            //   `Discover new and interesting news`,
            // ],
            tabCallout: `Dive into topics`
          },

          'more-topics': {
            theme: 'misc',
            icon: 'onboarding-find',
            title: `Deep dive into any <span class="callout">topic</span>`,
            // images: {
            //   dark: require('@assets/images/onboarding/more-topics.png'),
            //   light: require('@assets/images/onboarding/more-topics.png'),
            // },
            body: `Start exploring more news by tapping the <span class="callout">Headlines</span> tab and dive into a world of topics, countries and organisations.`,
            // bullets: [
            //   `Dive into the latest stories`,
            //   `Learn more about any topic`,
            //   `Discover related topics`,
            // ],
            tabCallout: `Ask Nourish anything`
          },

          'more-ask': {
            theme: 'misc',
            icon: 'onboarding-question',
            title: `Ask Nourish <span class="callout">anything</span>. Really: anything.`,
            // images: {
            //   dark: require('@assets/images/onboarding/more-read.png'),
            //   light: require('@assets/images/onboarding/more-read.png'),
            // },
            body: `Get a personalised answer to any story, topic or question. A wealth of knowledge from just a few words, at any time.`,
            // action: {
            //   route: '/topics',
            //   label: 'Start exploring'
            // }
            action: {
              route: '/search',
              label: 'Ask Nourish'
            }
          },

          'search-intro': {
            title: `Ask Nourish anything`,
            images: {
              dark: require('@assets/images/onboarding/search-intro.png'),
              light: require('@assets/images/onboarding/search-intro.png'),
            },
            body: `Have a question? You can search for any answer or gain insight into any topic with the 'Ask' tab.`,
            bullets: [
              `Ask anything`,
              `Get a detailed response`,
              `Discover specific news about your question`,
            ],
          },

          'search-ask': {
            title: `Simply ask your question, any question`,
            images: {
              dark: require('@assets/images/onboarding/search-ask.png'),
              light: require('@assets/images/onboarding/search-ask.png'),
            },
            body: `Nourish will give you a detailed answer to any question you ask.`,
          },

          'search-response': {
            title: `Nourish replies with a detailed answer`,
            images: {
              dark: require('@assets/images/onboarding/search-response.png'),
              light: require('@assets/images/onboarding/search-response.png'),
            },
            body: `Any question you ask, Nourish will summarise with what it knows and what's happening in the news.`,
            action: {
              route: '/search',
              label: 'Ask a question'
            }
          },

          'end-intro': {
            theme: 'pro',
            confetti: true,
            title: `You've completed your <span class="callout">detox!</span>`,
            dial: true,
            body: `Really great work! You've completed your 7 day detox and you're now reading the news in a healthy way.`,
            tabCallout: `Get more with<br>Nourish Pro`
          },

          'end-pro': {
            theme: 'pro',
            title: `Get more with <span class="callout">Nourish Pro</span>`,
            dial: true,
            body: `Nourish Pro supports our small team and helps us keep working to make the news better. You'll also unlock all channels instantly.`,
            meta: [
              {
                icon: 'meta-unlock',
                content: 'Unlock all<br>channels instantly',
              },
              {
                icon: 'meta-celebrate',
                content: 'Support our<br>small team',
              }
            ],
            event: {
              emit: 'didSelectSubscribe',
              label: 'Learn about Nourish Pro'
            }
          },

          'day-3': {
            dial: true,
            title: `Let's <span class="callout">unlock</span> the next ring!`,
            // images: {
            //   dark: require('@assets/images/onboarding/onboarding-graphic-alt-dark.png'),
            //   light: require('@assets/images/onboarding/onboarding-graphic-alt-light.png'),
            // },
            body: `You're halfway through your detox, making great progress and ready to choose the next ring to focus on.`,
            tabCallout: `Let's check-in quickly`
            // bullets: [
            //   `We hope you feel better, informed`,
            //   `You've unlocked the next ‘ring’`,
            //   `What will you pick?`,
            // ],
          },
          'day-3-ready': {
            dial: true,
            title: `Great! Let's <span class="callout">unlock</span> the next ring!`,
            // images: {
            //   dark: require('@assets/images/onboarding/onboarding-graphic-alt-dark.png'),
            //   light: require('@assets/images/onboarding/onboarding-graphic-alt-light.png'),
            // },
            body: `Let's focus on a different for the next few days. Ready to choose your next ring?`,
            tabCallout: `Choose your<br>next ring`
            // bullets: [
            //   `You won't need to read much more each day`,
            //   `Yet, will help achieve a better balance…`,
            //   `… and expand your perspectives`,
            // ],
          },

          'day-6': {
            dial: true,
            title: `You're ready for the <span class="callout">final</span> ring!`,
            body: `Great work making it this far! You've almost completed your detox. It's time to unlock the final ring!.`,
            tabCallout: `Let's check-in quickly`
          },
          'day-6-ready': {
            dial: true,
            title: `Great! Let's <span class="callout">unlock</span> the final ring!`,
            body: `Let's focus on a the final ring for the next few days. Ready to unlock?`,
            tabCallout: `Unlock the final ring`
          },
        } 
      }
    },

    watch: {
      isActive(to) {
        if (to) {
          this.slideActivated();
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5_stacks.scss';

  .card-onboarding {
    display: flex;
    flex-direction: column;
    max-width: 550px;
    margin: 0 auto;
    overflow-x: hidden;
    height: 100%;

    .desktop & {
      padding: 1rem 0;
    }

    .next {
      display: none;
    }

    // @media (min-width: 750px) {
    //   display: grid;
    //   grid-template-columns: 1fr 1fr;
    //   height: 75vh;

    //   .image-dial,
    //   .image-container,
    //   .main {
    //     align-self: center;
    //   }

    //   .main {
    //     display: flex;
    //     flex-direction: column;
    //     align-items: center;
    //     text-align: center;
    //     gap: 1rem;
    //   }

    //   .next {
    //     display: inline-block;
    //     min-width: 100px;
    //   }
    // }
  }

  .feature-cover {
    position: absolute;
    z-index: 0;
    right: 0;
    bottom: 0;
    height: 80%;
    width: 100%;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    .desktop & {
      bottom: 0;
      height: 45rem;
      width: 70%;
    }

    &.stretch {
      width: 100%;
      // height: 35rem;
      height: 80%;
      // bottom: 7rem;
      bottom: 0;
      left: 0;
      margin: 0 auto;

      .desktop & {
        width: 80%;
      }
    }
  }

  .main {
    // position: relative; - don't make a boundary
    z-index: 10;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    text-align: left;
    gap: 1rem;
    margin-top: 2rem;
    height: 100%;

    .desktop & {
      align-items: center;
      text-align: center;
    }

    .onboarding-content {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 1rem;

      &.mid {
        text-align: center;
        align-items: center;
        width: 100%;
      }

      .desktop & {
        align-items: center;
      }
    }

    .dial-explain {
      svg {
        height: 14rem;
        margin-left: 0.75rem;

        .brand {
          fill: $neutral-100;

          .darkmode & {
            fill: $neutral-600;
          }
        }
      }
    }

    .meta-block {
      z-index: 10;
      width: 100%;
      max-width: 400px;
      margin: 0 auto;
      margin-top: 1rem;
      // jim's hack
      position: absolute;
      bottom: 4.5rem;
      width: 90vw;
      left: 1rem;
      right: 1rem;
    }

    h1 {
      font-size: 50px;
      line-height: 100%;
      font-weight: normal;
      text-wrap: balance;

      ::v-deep {
        .callout {
          color: $yellow-tone-4;

          .darkmode & {
            color: $yellow-tone-3;
          }
        }

        .markout {
          text-decoration: line-through;
          // color: $neutral-400;
          opacity: .25;
        }
      }

      .desktop & {
        font-size: 70px;
      }
    }

    p {
      font-size: 20px;
      line-height: 150%;
      text-wrap: balance;
    }

    .features {
      display: flex;
      flex-direction: column;
      gap: 1.5rem;
      margin-top: 1.5rem;
      width: 100%;

      .desktop & {
        flex-direction: row;
        justify-content: center;
      }

      .feature {
        display: flex;
        align-items: center;
        gap: 0.75rem;
        font-size: 22px;
        font-weight: bold;

        svg path {
          fill: $yellow-tone-4;

          .darkmode & {
            fill: $yellow-tone-3;
          }
        }
      }
    }
  }

  .content {
    padding-bottom: 2rem;

    .feature-action {
      padding-bottom: 15px;
      font-size: 0.9rem;
      margin: 2rem auto 0 0;
      z-index: 10;

      .desktop & {
        margin: 2rem auto 0 auto;
      }
    }

    .image-icon {
      margin-bottom: 1rem;

      svg {
        fill: $yellow-tone-4;

        .darkmode & {
          fill: $yellow-tone-3;
        }
      }

      .desktop & {
        margin: 0 auto 1rem auto;
      }

      &.newsle-brand {
        margin: 1.5rem 0;

        svg {
          fill: $purple-tone-6;

          .darkmode & {
            fill: $neutral-600;
          }
        }
      }
    }

    .image-dial {
      margin: 0 auto 0 0;

      .desktop & {
        margin: 0 auto 0 auto;
      }
    }
    
    .image-container {
      margin: 0 0 2rem 0;

      img {
        width: 100%;
        max-width: 400px;
        max-height: 225px;
        object-fit: contain;
      }

      .dark {
        display: none;
      }

      .darkmode & {
        .light {
          display: none;
        }

        .dark {
          display: inline-block;
        }
      }
    }

    h1 {
      font-size: 50px;
      line-height: 100%;
      font-weight: normal;

      .callout {
        color: $yellow-tone-4;

        .darkmode & {
          color: $yellow-tone-3;
        }
      }

      .desktop & {
        font-size: 70px;
      }
    }

    ul {
      li {
        display: flex;
        align-items: center;
        font-size: 18px;
        margin-bottom: 1rem;


        svg {
          margin-right: 1rem;

          path {
            fill: $green-tone-3;
          }
        }
      }
    }
  }

  .locales {
    .main {
      h1 {
        ::v-deep {
          .callout {
            color: $blue-tone-3;

            .darkmode & {
              color: $locales-tone;
            }
          }
        }
      }
    }

    .image-icon {
      svg {
        fill: $blue-tone-3;

        .darkmode & {
          fill: $locales-tone;
        }
      }
    }
  }

  .topics {
    .main {
      h1 {
        ::v-deep {
          .callout {
            color: $green-tone-3;

            .darkmode & {
              color: $topics-tone;
            }
          }
        }
      }
    }

    .image-icon {
      svg {
        fill: $green-tone-3;

        .darkmode & {
          fill: $topics-tone;
        }
      }
    }
  }

  .time {
    .main {
      h1 {
        ::v-deep {
          .callout {
            color: $yellow-tone-4;

            .darkmode & {
              color: $time-tone;
            }
          }
        }
      }
    }

    .image-icon {
      svg {
        fill: $yellow-tone-4;

        .darkmode & {
          fill: $time-tone;
        }
      }
    }
  }

  .newsle {
    .main {
      h1 {
        ::v-deep {
          .callout {
            color: $purple-tone-3;

            .darkmode & {
              color: $purple-tone-2;
            }
          }
        }
      }
    }

    .image-icon {
      svg {
        fill: $purple-tone-3;

        .darkmode & {
          fill: $purple-tone-2;
        }
      }
    }

    .feature-action {
      background: $purple-tone-3;
      color: $neutral-600;

      .darkmode & {
        background: $purple-tone-2;
        color: $purple-tone-6;
      }
    }
  }

  .misc {
    .main {
      h1 {
        ::v-deep {
          .callout {
            color: $misc-tone;
          }
        }
      }
    }

    .image-icon {
      svg {
        fill: $misc-tone;

        .darkmode & {
          fill: $misc-tone;
        }
      }
    }

    .feature-action {
      background: $misc-tone;
      color: $neutral-600;
    }
  }

  .pro {
    .main {
      h1 {
        ::v-deep {
          .callout {
            color: $green-tone-3;

            .darkmode & {
              color: $green-tone-3;
            }
          }
        }
      }
    }

    .feature-action {
      background: $green-tone-3;
      color: $green-tone-6;
    }
  }

  .confetti {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 10rem;
    min-width: 500px;
    z-index: 0;
    background-image: url('@assets/images/onboarding-confetti.png');
    background-size: cover;
    background-position: bottom;

    .desktop & {
      height: 15rem;
    }
  }
</style>